export enum DraftReturnSource {
  FromOrder = "from_order",
  FromWarrantyRegistration = "from_warranty_registration",
  FromDraftRegistration = "from_draft_registration",
  FromProducts = "from_products",
}
